(function () {
  "use strict";

  var CDN_BASE = "https://cdn.shopify.com/s/files/1/0827/9172/7443/files/";

  /* Base images that identify each product type */
  var BRACELET_BASES = ["/files/7.png", "/files/6.png"];
  var NECKLACE_BASES = ["/files/CONN-BLANKGOL.png", "/files/CONN-BLANKSIL.png"];

  /*
   * Overlay configs — empirically measured via canvas pixel analysis
   * of the actual cart thumbnail base images (CONN-BLANKGOL.png, 7.png).
   * These are NOT the product page coordinates (different images entirely).
   */
  var CONFIGS = {
    bracelet: { cx: 0.48, cy: 0.47, d: 0.325 },
    necklace: { cx: 0.49, cy: 0.45, d: 0.285 }
  };

  function getProductType(src) {
    if (!src) return null;
    var clean = src.split("?")[0];
    for (var i = 0; i < BRACELET_BASES.length; i++) {
      if (clean.indexOf(BRACELET_BASES[i]) !== -1) return "bracelet";
    }
    for (var i = 0; i < NECKLACE_BASES.length; i++) {
      if (clean.indexOf(NECKLACE_BASES[i]) !== -1) return "necklace";
    }
    return null;
  }

  function parseVariants(text) {
    var result = { material: null, county: null };
    if (!text) return result;
    text.split(",").forEach(function (p) {
      var t = p.trim();
      if (t.toLowerCase().indexOf("material") !== -1) {
        var v = t.split(":")[1];
        if (v) result.material = v.trim().toLowerCase().indexOf("silver") !== -1 ? "silver" : "gold";
      }
      if (t.toLowerCase().indexOf("county") !== -1) {
        var v2 = t.split(":")[1];
        if (v2) result.county = v2.trim();
      }
    });
    return result;
  }

  function processCartItem(item) {
    var img = item.querySelector("img");
    if (!img) return;

    var type = getProductType(img.src);
    if (!type) {
      var old = item.querySelectorAll(".cart-county-ovl");
      old.forEach(function (el) { el.remove(); });
      return;
    }

    var kvEl = item.querySelector('[class*="key-value-pair"]');
    var parsed = parseVariants(kvEl ? kvEl.textContent : "");
    if (!parsed.county || !parsed.material) {
      item.querySelectorAll(".cart-county-ovl").forEach(function (el) { el.style.display = "none"; });
      return;
    }

    var cfg = CONFIGS[type];
    var url = CDN_BASE + parsed.county + "_" + parsed.material + ".png";
    var wrapper = img.parentElement;
    if (wrapper && getComputedStyle(wrapper).position === "static") {
      wrapper.style.position = "relative";
    }

    var ovl = wrapper.querySelector(".cart-county-ovl");
    if (!ovl) {
      ovl = document.createElement("div");
      ovl.className = "cart-county-ovl";
      ovl.style.cssText = "position:absolute;pointer-events:none;z-index:2;border-radius:50%;overflow:hidden";
      var oImg = document.createElement("img");
      oImg.style.cssText = "display:block;width:100%;height:100%;object-fit:contain";
      oImg.alt = "";
      oImg.draggable = false;
      ovl.appendChild(oImg);
      wrapper.appendChild(ovl);
    }

    var oImg = ovl.querySelector("img");
    if (oImg.getAttribute("data-src") !== url) {
      oImg.setAttribute("data-src", url);
      oImg.src = url;
    }

    ovl.setAttribute("data-type", type);

    var w = img.offsetWidth, h = img.offsetHeight;
    if (w === 0 || h === 0) return;
    var ref = Math.min(w, h);
    var sz = ref * cfg.d;
    ovl.style.width = sz + "px";
    ovl.style.height = sz + "px";
    ovl.style.left = (w * cfg.cx - sz / 2) + "px";
    ovl.style.top = (h * cfg.cy - sz / 2) + "px";
    ovl.style.display = "block";
  }

  function processAll(sr) {
    sr.querySelectorAll(".upcart-internal-cart-item").forEach(processCartItem);
  }

  function watchUpcart() {
    var host = document.querySelector("#upCart");
    if (!host || !host.shadowRoot) return false;
    var sr = host.shadowRoot;
    processAll(sr);
    var obs = new MutationObserver(function () {
      clearTimeout(obs._t);
      obs._t = setTimeout(function () { processAll(sr); }, 200);
    });
    obs.observe(sr, { childList: true, subtree: true, attributes: true, attributeFilter: ["src", "class"] });
    return true;
  }

  function init() {
    if (watchUpcart()) return;
    var n = 0, iv = setInterval(function () { n++; if (watchUpcart() || n > 60) clearInterval(iv); }, 500);
  }

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
})();